module.exports = __webpack_public_path__ + "static/media/sendNotification.5b08a89d.svg";